/**
 * An uploaded file's address, as the browser needs it.
 *
 * The API stores and returns these as paths of its own — "/uploads/event/x.jpg" — which
 * resolve against whatever is serving the page. In development that is the dev server on
 * :3000, which holds no uploads at all, so every banner, avatar and attachment came back
 * 404 and rendered as a broken image. Deployed, the two happen to share an origin and it
 * works by luck rather than by design.
 *
 * Several pages already did this inline (noticeBoard, userProfile, mentionInput,
 * bestMonthlyLeaderboard). This is the same rule in one place.
 */
const STATIC_BASE = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/api\/?$/, '');

export function fileUrl(path) {
    if (!path) return undefined;
    // Already absolute — an external image, or a full URL somebody pasted in.
    if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) return path;
    return STATIC_BASE + (path.startsWith('/') ? path : `/${path}`);
}

export default fileUrl;
